// Zero trust from cloudflare sets the cookies for an app to define if the domain which tries accessing back-end is valid
// we are fetching those cookies manually and sending including the in headers via interceptor
export const getCfSessionToken = () => {
    let cfAccessJwt = null;
    const cookies = document.cookie.split('; ');
    for (const cookie of cookies) {
        if (cookie.startsWith('CF_Authorization=')) {
            cfAccessJwt = cookie.split('=')[1];
            break;
        }
        if (cookie.startsWith('cf_authorization=')) {
            cfAccessJwt = cookie.split('=')[1];
            break;
        }
    }
    return cfAccessJwt;
};
// export const getCfSessionToken = async (url: string) => {
//   const urlToUse = url.replace('/graphql', '/cdn-cgi/access/session');
//   try {
//     const res = await fetch(urlToUse, {
//       credentials: 'include',
//     });
//     const session = await res.json();
//     return session?.token;
//   } catch (err) {
//     console.warn('Unable to get CF Access token');
//   }
// };
//# sourceMappingURL=cfSessionHelpers.js.map